import {
  createRequestTypes,
  createActions,
  REQUEST,
  SUCCESS,
  FAILURE
} from "./index";

export const LOCATION = createRequestTypes("LOCATION");
export const location = {
  request: () => createActions(LOCATION[REQUEST]),
  success: data => createActions(LOCATION[SUCCESS], data),
  failure: error => createActions(LOCATION[FAILURE], error)
};
